;(function () {
  angular
    .module('contrast.notifications')
    .factory('notificationApiConfig', notificationApiConfig)

  function notificationApiConfig($http, UserService) {
    'ngInject'

    return {
      markAsRead: function (data) {
        return $http.put(UserService.buildAPIUrl('/notifications'), data)
      },
      markAllAsRead: function () {
        return $http.put(UserService.buildAPIUrl('/notifications/read'))
      },

      //org settings
      getOrganizationSettings: function () {
        return $http.get(UserService.buildAPIUrl('/notifications/organization'))
      },
      updateOrganizationSettings: function (data) {
        return $http.put(
          UserService.buildAPIUrl('/notifications/organization'),
          data
        )
      },
      updateOrganizationNotificationType: function (triggerType, data) {
        return $http.put(
          UserService.buildAPIUrl('/notifications/organization/' + triggerType),
          data
        )
      },
      cleanOrganizationNotificationType: function (triggerType, data) {
        return $http['delete'](
          UserService.buildAPIUrl('/notifications/organization/' + triggerType),
          {
            data: data,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      updateOrganizationNotifyOnUpdate: function (data) {
        return $http.put(
          UserService.buildAPIUrl('/notifications/organization/status'),
          data
        )
      },
      updateOrganizationNotificationChannel: function (
        triggerType,
        channelType,
        data
      ) {
        return $http.put(
          UserService.buildAPIUrl(
            '/notifications/organization/' +
              triggerType +
              '/channel/' +
              channelType
          ),
          data
        )
      },

      //user settings
      getUserSettings: function () {
        return $http.get(UserService.buildAPIUrl('/notifications/user'))
      },
      updateUserSettings: function (data) {
        return $http.put(UserService.buildAPIUrl('/notifications/user'), data)
      },
      updateUserNotificationType: function (triggerType, data) {
        return $http.put(
          UserService.buildAPIUrl('/notifications/user/' + triggerType),
          data
        )
      },
      cleanUserNotificationType: function (triggerType, data) {
        return $http['delete'](
          UserService.buildAPIUrl('/notifications/user/' + triggerType),
          {
            data: data,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      updateUserNotificationNotifyOnChange: function (triggerType, data) {
        return $http.put(
          UserService.buildAPIUrl(
            '/notifications/user/' + triggerType + '/status'
          ),
          data
        )
      },
      updateUserNotificationChannel: function (triggerType, channelType, data) {
        return $http.put(
          UserService.buildAPIUrl(
            '/notifications/user/' + triggerType + '/channel/' + channelType
          ),
          data
        )
      },
      updateUserNotificationApplicationSubscription: function (data) {
        return $http.put(
          UserService.buildAPIUrl('/notifications/user/application'),
          data
        )
      },
      cleanUserNotificationApplicationSubscription: function (data) {
        return $http['delete'](
          UserService.buildAPIUrl('/notifications/user/application'),
          {
            data: data,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      restoreDefaults: function () {
        return $http.put(UserService.buildAPIUrl('/notifications/user/reset'))
      }
    }
  }
})()
